import { IPalettes } from './types';

export const CSS_DEFAULT_PALETTES: IPalettes = {
  primary: 'rgba(0, 150, 136, 1)',
  accent: 'rgba(233, 30, 99, 1)',
  bg: 'rgba(250, 250, 250, 1)',
  text: false,
};
